import React, { useEffect, useState } from 'react';
import { Input } from '@flixbus/honeycomb-react';
import { useVoucherFormContext } from '../../Context';
import { AllowedCustomerRule } from '../../../../types/Rules';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const AllowedCustomerRuleEditor: React.FC = () => {
  const {
    formState: {
      payload: { rules },
    },
    handleRuleChange,
    setFormError,
  } = useVoucherFormContext();

  const [email, setEmail] = useState('');
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    const existingRule = rules.find(r => r.type === 'allowed_customer') as
      | AllowedCustomerRule
      | undefined;
    const emailIdentifier = existingRule?.identifiers.find(i => i.type === 'email');
    setEmail(emailIdentifier?.value ?? '');
  }, [rules]);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);

    if (value.trim() === '') {
      setFormError('allowed_customer_email', null);
      handleRuleChange({ type: 'allowed_customer', identifiers: [] }, true);
    } else if (EMAIL_REGEX.test(value.trim())) {
      setFormError('allowed_customer_email', null);
      handleRuleChange({
        type: 'allowed_customer',
        identifiers: [{ type: 'email', value: value.trim() }],
      });
    } else {
      setFormError('allowed_customer_email', 'Please enter a valid email address');
    }
  };

  const isInvalid = touched && email.trim() !== '' && !EMAIL_REGEX.test(email.trim());

  const isEnabled = localStorage.getItem('enable-allowed-customer-rule') === 'true';

  if (!isEnabled) {
    return null;
  }

  return (
    <Input
      id='allowed-customer-email'
      name='allowed-customer-email'
      label='Customer Email'
      type='email'
      value={email}
      onChange={handleEmailChange}
      onBlur={() => setTouched(true)}
      valid={isInvalid ? false : undefined}
      infoError='Please enter a valid email address'
      info='The voucher can only be redeemed by this customer'
    />
  );
};

export default AllowedCustomerRuleEditor;
